// extracted by mini-css-extract-plugin
export default {"container":"JobseekerProfile_container__CC5le","editContainer":"JobseekerProfile_editContainer__3Xi7F","fcvRow":"JobseekerProfile_fcvRow__po4n-"};